module.exports = __webpack_public_path__ + "img/visa.587ba043.svg";